import React, {useState, useEffect} from 'react';
import { format, parseISO } from 'date-fns';
import {MODIMAGEPATH} from '../api';
import { useDispatch, useSelector } from 'react-redux';
import getWeatherForcast from '../api/weather';
import getAddress from '../api/address';
import { changeCameraOnMap } from '../../actions/mapAction';
import { setWeatherData, setAddressData, setIsFade} from '../../actions/webcamAction';
import TnTempSlider from './../TnWebCam/TnTempSlider';
import Language from './../../../src/language/language.json';


const TnWebCamBottom = (props) => {
    //console.log("from TnWebCamBottom", props);
    const dispatch = useDispatch();
    const webcam = useSelector((store)=>store.webcam);
    var {cams, 
        activeCamera, 
        weatherData,
        addressData,
        isFade,
        isSidebar} = webcam;
    const wdata = weatherData['cam'+activeCamera];    
    const place = addressData['cam'+activeCamera];
    const localTime = wdata?.Info?.Forecast_Calculated_LocalTime;
    const date_time = (typeof localTime !== 'undefined') ? localTime.split('T') : [];
    let date = (typeof date_time[0] !== 'undefined') ? date_time[0] : '';
    const time = (typeof date_time[1] !== 'undefined') ? date_time[1].split('+')[0] : '';
    let imageIcon = wdata?.Current?.Icon;

    

    if(imageIcon){
        imageIcon = imageIcon.replace(".png", ".svg");
    }
    
    if(date){
        date = format(parseISO(date), "dd.MM.yyyy");        
    }

    const putMarkersOnMap = (camid) => {
        var markers = {'camera': cams['ordered'+camid], 'accommodation': props.accomodation};
        dispatch(changeCameraOnMap(markers));
    }
    const handleFadeOnClick = ()=>{
        dispatch(setIsFade(!isFade));
    }
    
    useEffect(()=>{
        
        if(activeCamera && 'ordered'+activeCamera in cams){
            putMarkersOnMap(activeCamera);
            if(weatherData['cam' + activeCamera] === null
                && cams['ordered'+activeCamera]?.latitude
                && cams['ordered'+activeCamera]?.longitude){
                (async()=>{ 
                    var request = {
                        camid: cams['ordered'+activeCamera]?.id,
                        lat: cams['ordered'+activeCamera]?.latitude,
                        lon: cams['ordered'+activeCamera]?.longitude,
                        alt: 200, 
                        v: 'premium'
                    }
                    await getWeatherForcast(request).then((data)=>{
                        dispatch(setWeatherData(data, activeCamera));
                    });                    
                })();
            }
            if(addressData['cam' + activeCamera] === null
                && cams['ordered'+activeCamera]?.latitude
                && cams['ordered'+activeCamera]?.longitude){
                (async()=>{ 
                    var request = {
                        camid: cams['ordered'+activeCamera]?.id,
                        lat: cams['ordered'+activeCamera]?.latitude,
                        lon: cams['ordered'+activeCamera]?.longitude
                    }
                    await getAddress(request).then((data)=>{
                        dispatch(setAddressData(data, activeCamera));
                        putMarkersOnMap(activeCamera);
                    });                    
                })();                
            }
        }
    },[activeCamera]);

    return(
        <>
            {isSidebar ? 
            <TnTempSlider key={"key"+activeCamera} />
            : <></>}
            <div className='TnWebcamSliderBottom-btn' onClick={handleFadeOnClick} ></div>
            
            <div className={'TnWebcamSliderBottom '+(isFade || isSidebar ? '' : 'hide')}>
                <div className='tn-webcam-slider-bottom'>

                    <div className='tn-webcam-slider-bottom-inner'>

                        <div className="slider-content">
                            <div className="slider-content-top">
                                    <div className="slider-content-date">
                                        <span className="slide-content-title">{time}</span>
                                        <span>{date}</span>
                                    </div>
                                    <div className="slider-content-place">
                                        <a onClick={(e)=>{e.preventDefault();return false;}} href={'/'} title={cams['ordered'+activeCamera]?.name} alt={cams['ordered'+activeCamera]?.name}><span className="slide-content-title">{cams['ordered'+activeCamera]?.name}</span></a>
                                        <span>{place?.address?.country_code} | {place?.address?.state}</span>
                                    </div>
                                    <div className="slider-content-temp">
                                        <div className="slider-content-temp-lt">                                    
                                            <img src={MODIMAGEPATH + "svg/" + imageIcon } alt="" />                                    
                                        </div>
                                        <div className="slider-content-temp-rt">
                                            <span className="slide-content-title">{wdata?.Current?.Temperature} {wdata?.Current?.Temperature_Unit}</span>
                                            <span>{wdata?.Current?.PrecipitationRain_Intensity} {wdata?.Current?.PrecipitationRain_Intensity_Unit} 
                                            {" | "} 
                                            {wdata?.Current?.TotalCloudCover} {wdata?.Current?.TotalCloudCover_Unit}</span> 
                                        </div>
                                    </div>
                                    
                                <div className="slider-content-text">
                                    <span className="slide-content-title">{cams['ordered'+activeCamera]?.text ? Language[props.lang]?.providedByLabel : ""}</span>
                                    <span>
                                        <a target="_blank" rel={cams['ordered'+activeCamera]?.nofollow ? 'nofollow' : 'follow'} href={cams['ordered'+activeCamera]?.link} alt={cams['ordered'+activeCamera]?.title} title={cams['ordered'+activeCamera]?.title}>
                                            {cams['ordered'+activeCamera]?.text}
                                        </a>
                                    </span>
                                </div>
                                <div className="slider-social-nav">
                                    <a target="_blank" href={"https://www.facebook.com/sharer.php?u=" + cams['ordered'+activeCamera]?.url + "&t=" + cams['ordered'+activeCamera]?.name}>
                                        <img src={MODIMAGEPATH + "fb.png"} alt="" />
                                    </a>
                                    <a target="_blank" href={"https://pinterest.com/pin/create/button/?url=" + cams['ordered'+activeCamera]?.url + "&description=" + cams['ordered'+activeCamera]?.name + "&media=" + cams['ordered'+activeCamera]?.campicurl} >
                                        <img src={MODIMAGEPATH + "pintrest.png"} alt="" />
                                    </a>
                                    <a target="_blank" onClick={(e)=>{e.preventDefault();window.open('https://webcamwidget.fullmarketing.at/ecardjoom.php?id=' + cams['ordered'+activeCamera]?.id + '&lang=' + props?.lang ,'popup','width=460,height=500'); return false;}} href={"/"}>
                                        <img src={MODIMAGEPATH + "email.png"} alt="" />
                                    </a>
                                    
                                </div>
                            </div>
                            <div className="slider-content-bottom">
                                {props.copyrightlink ? 
                                    <a rel={props?.nofollow ? 'nofollow' : 'follow'} href={props.copyrightlink} alt={props.copyrighttitle} title={props.copyrighttitle} target="_blank">
                                        {props.copyrighttext}
                                    </a>
                                :
                                    <>{props.copyrighttext}</>
                                }
                            </div>
                        </div>

                    </div>
                    
                </div>
            </div>
        </>
    )
}


export default TnWebCamBottom;